<template>
	<div class="section">
		<div class="layui-container">
			<ul class="media-row">
				<li v-for="(item,index) in newsList" :key="index">
					<div class="media-card" @click="goUrl('/news-detail')">
						<div class="media-photo scale"><img :src="item.pic" alt="" /></div>
						<div class="media-grid">
							<div class="media-time">2024年6月18</div>
							<div class="media-title">
								<span>{{item.title}}</span>
							</div>
							<div class="media-desc">
								{{item.desc}}
							</div>
							<div class="layui-text-orange">查看全文</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				newsList:[
					{
						title:'文章标题文章标题文章标题文章标题文章标题文章标题文章标题',
						pic:require('@/assets/images/artice-a.jpg'),
						desc:'我给宠物花的最值的钱，应该是几年前，出门遛狗。路过摆摊算命的老头，看他也没啥生意，我就想着支持一下，也有点走不动了。谁知道，那',
					},{
						title:'文章标题商品名称商文章标题品名称商品名称',
						pic:require('@/assets/images/artice-b.jpg'),
						desc:'我给宠物花的最值的钱，应该是几年前，出门遛狗。路过摆摊算命的老头，看他也没啥生意，我就想着支持一下，也有点走不动了。谁知道，那',
					},
				]
			};
		},
		mounted() {}
	}
</script>
